var uiCopyToClipboard = {
	copy: "Copy \"{value}\" to clipboard",
	successMessage: "Copied",
	failureMessage: "Unable to copy"
};
var uiCopyToClipboardTranslationsEn = {
	uiCopyToClipboard: uiCopyToClipboard
};

export { uiCopyToClipboardTranslationsEn as default, uiCopyToClipboard };
